import React, { useEffect, useMemo, useRef } from "react";
import CollapsedBox from "../../../components/CollapsedBox";
import { useBillingPlans } from "../../../context/billingPlans";
import { PaymentStep, PlanType } from "../../../utils/types";
import PlansUpgrade from "../PlansUpgrade";

const PrepaidVolumeDiscounts: React.FC = () => {
  const {
    newPlan,
    setNewPlan,
    setPaymentStep,
    paymentStep,
    getPrePaidPlanByType
  } = useBillingPlans();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const workspacePlansContainer = useMemo(
    () => document.getElementById("workspace-plans-container"),
    []
  );

  useEffect(() => {
    if (paymentStep !== PaymentStep.featuresByDemand) {
      return;
    }

    containerRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [paymentStep]);

  return (
    <div ref={containerRef}>
      <CollapsedBox
        className="mt-5 lg:mt-8"
        title="Add hotspots & super simulations"
        icon="2."
        opened={paymentStep === PaymentStep.featuresByDemand}
        saveButtonName="Continue"
        setOpened={() => setPaymentStep(PaymentStep.featuresByDemand)}
        onClickButton={(type) => {
          if (type === "save") {
            setPaymentStep(PaymentStep.paymentReview);

            return;
          }

          setPaymentStep(PaymentStep.choosePlan);
          workspacePlansContainer?.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <div>
          <PlansUpgrade
            className="border-0 border-b rounded-b-none shadow-none p-3 sm:p-5"
            min={1}
            max={20000}
            title="Hotspots"
            subtitle={
              <>
                <div>
                  <b>{newPlan.hotspotAmount.toLocaleString(undefined)}</b>{" "}
                  hotspots
                </div>
                <div>
                  <b>{(newPlan.hotspotAmount * 2).toLocaleString(undefined)}</b>{" "}
                  locations
                </div>
              </>
            }
            value={newPlan.hotspotAmountPrice}
            disabled={newPlan.plan?.type === PlanType.community}
            amount={newPlan.hotspotAmount}
            priceTiers={
              getPrePaidPlanByType(PlanType.prePaidHotspot)?.price_tiers
            }
            onChange={(value) =>
              setNewPlan((prevState) => ({
                ...prevState,
                hotspotAmount: value
              }))
            }
          />

          <PlansUpgrade
            className="border-0 shadow-none per month p-3 sm:p-5"
            min={1}
            max={20000}
            title="Simulations per month"
            subtitle={
              <>
                <div>
                  <b>{newPlan.simulationAmount.toLocaleString(undefined)}</b>{" "}
                  simulations
                </div>
                <div>
                  <b>
                    {(newPlan.simulationAmount * 2).toLocaleString(undefined)}
                  </b>{" "}
                  locations
                </div>
              </>
            }
            value={newPlan.simulationAmountPrice}
            disabled={newPlan.plan?.type === PlanType.community}
            amount={newPlan.simulationAmount}
            priceTiers={
              getPrePaidPlanByType(PlanType.prePaidSimulation)?.price_tiers
            }
            onChange={(value) =>
              setNewPlan((prevState) => ({
                ...prevState,
                simulationAmount: value
              }))
            }
          />
        </div>
      </CollapsedBox>
    </div>
  );
};

export default PrepaidVolumeDiscounts;
